import React from 'react'
import JasminCommerceBox from '@/components/molecules/JasminCommerceBox/JasminCommerceBox'
import { Image, CustomLinkComponent } from 'msp-components'
import { useWindowSize, productUrlBuilder } from 'msp-integrations'
import useProduct from '@/hooks/use-product'
import * as S from './ProductSetTeasers.styles'
import type { ProductSetTeaserProps } from './ProductSetTeaser.types'

const ProductSetTeaser = ({ custom, data }: ProductSetTeaserProps) => {
  const {
    productName,
    productId,
    subtitle,
    copy,
    backgroundImageAlt,
    productImageAlt,
    imageMobileAlt
  } = data
  const { backgroundImage, imageMobile, productImage } = custom?.content || {}
  const product = useProduct(productId)
  const { imageGroups } = product || {}
  const { images = {} } = imageGroups ? imageGroups[0] : {}
  const productFeaturedImage = images ? images[0] : {}
  const { link: productFeaturedImageURL, title: productFeaturedImageAlt } =
    productFeaturedImage || {}

  const { width, breakpoints } = useWindowSize()
  const isMobile = width && width < breakpoints.md
  const isSmallMobile = width && width < breakpoints.xs

  const urlToPDP = productUrlBuilder({
    name: product?.name || '',
    id: productId,
    classCategoryName: product?.c_classCategoryName,
    classCategoryPath: product?.c_classCategoryPath,
    primaryCategoryName: product?.c_primaryCategoryName,
    primaryCategoryPath: product?.c_primaryCategoryPath
  })

  return (
    <div className={S.wrapper}>
      <div className={S.productColumn}>
        <CustomLinkComponent href={urlToPDP} className={S.productLink} inline>
          <h2 className={S.productName}>{productName}</h2>
        </CustomLinkComponent>
        <div className={S.productContent}>
          <p className={S.subtitle}>{subtitle}</p>
          <p className={S.copy}>{copy}</p>
        </div>
        <JasminCommerceBox
          data={{
            productId: productId,
            type: isMobile ? 'XS' : 'LG'
          }}
          showWishListButton={!isSmallMobile}
          noPadding
        />
      </div>
      <div className={S.imagesColumn}>
        {(productImage || productFeaturedImageURL) && (
          <CustomLinkComponent
            href={urlToPDP}
            className={S.productLink}
            inline
            ariaLabel={`View details for ${
              productImageAlt || productFeaturedImageAlt
            }`}
          >
            <Image
              className={S.productImage}
              src={productImage || productFeaturedImageURL}
              alt={productImageAlt || productFeaturedImageAlt}
              loading='eager'
              fetchPriority='high'
            />
          </CustomLinkComponent>
        )}
        <Image
          className={`h-full w-full object-cover`}
          src={isMobile ? imageMobile || backgroundImage : backgroundImage}
          alt={
            isMobile ? imageMobileAlt || backgroundImageAlt : backgroundImageAlt
          }
          loading='eager'
        />
      </div>
    </div>
  )
}

export default ProductSetTeaser
